export class LoginAction {
  static type = '[USER] Login';

  constructor(readonly email: string, readonly password: string) {}
}
